import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import search from '@/libs/search';

import { getAreaList } from '@/api/modules/system-management/area-management';

export const getMasterUserList = data => {
    return axios.request({
        url: 'api/accountManagement/masterUserManagement/getMasterUserList',
        data: data,
        method: 'post'
    });
};

export const getMasterUserDetail = userMasterLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/masterUserManagement/getMasterUserDetail',
        data: { userMasterLoginUuid },
        method: 'post'
    });
};

export const pageInit4UserMasterEdit = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch)
    ]).then(axiosRequest.spread(function (area) {
        if (area.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data
                }
            };
        }
    }));
};

export const masterUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/masterUserManagement/masterUserSave',
        data: data,
        method: 'post'
    });
};
